<template>
<el-table :data="tableData" style="width: 100%" :show-header="false" @row-click="gotoEdit">
    <el-table-column label="">
        <template slot-scope="scope">
            <div class="d-flex justify-content-start align-items-center">
                <NameInitials :name="scope.row.name" small color="#727D94" />
                <p class="c-ndarkfour medium mb-0 break-name">
                    {{ scope.row.name | formatName }}
                </p>
                <caption class="ml-3 mb-0">
                    {{ userGroupProfiles(scope.row.cnpjs[0].userCnpjs.userAllowedProfiles) }}
                </caption>
            </div>
        </template>
    </el-table-column>
    <el-table-column width="200px" label="buttons">
        <template slot-scope="scope">
            <div class="d-flex justify-content-end align-items-center">
                <div class="mr-3">
                    <UserStatus :status="scope.row.emailChecked" />
                </div>
                <el-dropdown class="points-dropdown" trigger="click">
                    <span class="el-dropdown-link">
                        <DropdownIcon />
                    </span>
                    <el-dropdown-menu slot="dropdown">

                        <el-dropdown-item>
                            <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="gotoEditButton(scope.row)">
                                <Edit class="mr-2"/>Editar
                            </span>
                        </el-dropdown-item>

                        <el-dropdown-item>
                            <span class="c-sredfour medium pl-3 d-flex align-items-center" @click="deleteUser(scope.row)">
                                <TrashIcon color="#E54949" class="mr-2"/>Excluir
                            </span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </template>
    </el-table-column>
</el-table>
</template>

<script>
import DropdownIcon from '@/components/icons/Dropdown'
import NameInitials from '@/components/icons/NameInitials'
import UserStatus from '@/components/status/UserStatus'
import Edit from '@/components/icons/Edit'
import TrashIcon from '@/components/icons/Trash'
export default {
    components: {
        DropdownIcon,
        NameInitials,
        UserStatus,
        Edit,
        TrashIcon,
    },
    props: {
        tableData: {
            required: true
        },
        originalRoute: {
            required: false,
            default: '/user'
        }
    },
    methods: {
        userGroupProfiles(userGroupProfiles) {
            return userGroupProfiles == 'all'
                ? 'financiador | comprador' : userGroupProfiles == '0'
                ? 'financiador' : userGroupProfiles == '2'
                ? 'comprador' : ''
        },
        deleteUser(user) {
            this.$emit('deleteUserModal', user)
        },
        gotoEditButton(row) {
            this.$router.push(`/user/group/${this.$route.params.groupId}/edit/${row.id}?originalRoute=${this.originalRoute}`)
        },
        gotoEdit(row, column) {
            if (this.USER_TYPE_MIXIN.isBackOffice) return
            if (!column.label.length) {
                this.$router.push(`/user/group/${this.$route.params.groupId}/edit/${row.id}?originalRoute=${this.originalRoute}`)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
